<div class="aza-activity-details aza-vertical-stack">
  <div class="aza-vertical-stack aza-flex-grow activity-name-start-end">
    <div class="aza-activity-list-item-name aza-text aza-heading activity-name">
      <span>{{activity.name}}</span>
    </div>
    <div class="activity-date-range">
      <div class="activity-start">
        <span class="activity-start-label" translate>START</span>:
        <span>{{activity.start | eventDate:eventSettings.timezone:eventSettings.datetime_format}}</span>
      </div>
      <div class="activity-end">
        <span class="activity-end-label" translate>END</span>:
        <span>{{activity.end | eventDate:eventSettings.timezone:eventSettings.datetime_format}}</span>
      </div>
    </div>
    @if (activity.description) {
      <div class="activity-description">
        <span class="activity-description-label" translate>DESCRIPTION</span>:
        <div class="activity-descriptioin-text">{{activity.description}}</div>
      </div>
    }
    @if (activity.summary) {
      <div class="activity-summary">
        <span class="activity-summary-label" translate>SUMMARY</span>:
        <div class="activity-summary-text">{{activity.summary}}</div>
      </div>
    }
    @if (activity.url) {
      <div class="activity-url">
        <span translate>URL</span>:
        <a [href]="activity.url" class="activity-url-link">{{activity.url}}</a>
      </div>
    }
    @if (activity.speaker_info) {
      <div class="activity-speaker-info">
        <label class="activity-speaker-info-label" translate>SPEAKER_INFO</label>:
        <span>{{activity.speaker_info}}</span>
      </div>
    }
    @if (activity.room) {
      <div class="activity-room">
        <label class="activity-room-label" translate>ROOM</label>:
        <span>{{activity.room}}</span>
      </div>
    }
  </div>
  <aza-rws-like-unlike [isLiked]="activity.liked" (liked)="onLikeActivity(activity)"
    (unliked)="onUnlikeActivity(activity)" class="activity-like-unlike">
  </aza-rws-like-unlike>
</div>
